<ng-container *ngIf="locationForm">
	<div class="row">
		<div class="col-6 text-left">
			<button mat-raised-button (click)="cancel()" >Cancel</button>
		</div>
		<div class="col-6 text-right">
			<button mat-raised-button (click)="updateLocation()" color="accent">Save</button>
		</div>
	</div>
	<form [formGroup]="locationForm" class="text-dark">
		<div class="row">
			<div class="col-md-8">
				<div class="card card-profile">
					<div class="card-body">
						<h6 class="card-category text-gray">Location Details</h6>
						<div class="row">
							<div class="col-md-12">
								<mat-form-field class="full-width" appearance="outline">
									<input matInput required formControlName="loccode" placeholder="Loc Code" [value]="ld?.loccode">
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Location Name</mat-label>
									<input matInput formControlName="locationname" placeholder="Location Name" [value]="ld?.locationname">
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-md-6">
								<mat-form-field class="full-width" appearance="outline">
									<input matInput placeholder="Address 1" formControlName="deladd1" [value]="ld?.deladd1">
								</mat-form-field>
							</div>
							<div class="col-md-6">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Address 2</mat-label>
									<input matInput placeholder="Address 2" formControlName="deladd2" [value]="ld?.deladd2">
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>City</mat-label>
									<input matInput placeholder="City" formControlName="deladd3" [value]="ld?.deladd3">
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline">
                                                                        <mat-label>Region</mat-label>
									<mat-select formControlName="deladd4">
										<mat-option *ngFor="let zone of zones.zones" [value]="zone.code">
											{{zone.code}} {{zone.name}}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<input matInput placeholder="Postal" formControlName="deladd5" [value]="ld?.deladd5">
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<mat-form-field appearance="outline" class="">
									<mat-label>Country</mat-label>
									<mat-select formControlName="deladd6" (selectionChange)="updateZones($event)">
										<mat-option *ngFor="let zone of zones.countries" [value]="zone.name">
											{{ zone.name }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>

							<div class="col-md-6">
								<mat-form-field appearance="outline" *ngIf="taxes">
									<mat-label>Tax Authority With Cert</mat-label>
									<mat-select formControlName="taxgroupid_cert">
										<mat-option *ngFor="let tax of taxes" [value]="tax.taxgroupid">
											{{tax.taxgroupdescription}}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>

							<div class="col-md-6">
								<mat-form-field appearance="outline" *ngIf="taxes">
									<mat-label>Tax Authority Without Cert</mat-label>
									<mat-select formControlName="taxgroupid">
										<mat-option *ngFor="let tax of taxes" [value]="tax.taxgroupid">
											{{tax.taxgroupdescription}}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>

						</div>
					</div>
				</div>
			</div>
			<div class="col-md-4">
				<div class="card card-profile">
					<div class="card-body">
						<h6 class="card-category text-gray">Location Contact</h6>
						<div class="row">
							<div class="col-md-12">
								<mat-form-field class="full-width" appearance="outline">
									<input formControlName="contact" matInput placeholder="Contact Name" [value]="ld?.contact">
								</mat-form-field>
							</div>
							<div class="col-md-12">
								<mat-form-field class="full-width" appearance="outline">
									<input formControlName="email" matInput placeholder="Location Email" [value]="ld?.email">
								</mat-form-field>
							</div>
							<div class="col-md-12">
								<mat-form-field class="full-width" appearance="outline">
									<input formControlName="tel" matInput placeholder="Location Phone" [value]="ld?.tel">
								</mat-form-field>
							</div>
							<div class="col-md-12">
								<mat-form-field class="full-width" appearance="outline">
									<input formControlName="fax" matInput placeholder="Location Fax" [value]="ld?.fax">
								</mat-form-field>


								<angular-editor formControlName="receipt_message" [config]="editorConfig"></angular-editor>


							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<div class="card card-profile">
					<div class="card-body">
						<h6 class="card-category text-gray">Location Defaults</h6>
						<div class="row">
							<div class="col-md-4">
								<mat-form-field appearance="outline" class="">
									<mat-label>Country</mat-label>
									<mat-select formControlName="defcountry">
										<mat-option *ngFor="let zone of zones.countries" [value]="zone.name">
											{{ zone.name }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline">
                                    <mat-label>Region</mat-label>
									<mat-select formControlName="defregion">
										<mat-option *ngFor="let zone of zones.zones" [value]="zone.code">
											{{zone.code}} {{zone.name}}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline">
                                    <mat-label>Default Customer A/R Status</mat-label>
									<mat-select formControlName="defholdreason">
										<mat-option *ngFor="let hr of holdreasons" [value]="hr.reasoncode">
											{{hr.reasoncode}} - {{hr.reasondescription}}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline">
                                    <mat-label>Currency</mat-label>
									<mat-select formControlName="defcurrency">
										<mat-option *ngFor="let cur of currencies" [value]="cur.currabrev">
											{{cur.currabrev}} - {{cur.currency}}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline">
                                    <mat-label>Payment Terms</mat-label>
									<mat-select formControlName="defterms">
										<mat-option *ngFor="let term of terms" [value]="term.termsindicator">
											{{term.termsindicator}} {{term.terms}}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline">
                                    <mat-label>Price Level</mat-label>
									<mat-select formControlName="defsalestype">
										<mat-option *ngFor="let type of salestypes" [value]="type.typeabbrev">
											{{type.typeabbrev}} - {{type.sales_type}}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline">
                                    <mat-label>New Customer Type</mat-label>
									<mat-select formControlName="defcustomertype">
										<mat-option *ngFor="let type of types" [value]="type.typeid">
											{{type.typename}}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Discount %</mat-label>
									<input formControlName="defdiscount" matInput placeholder="Discount">
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Credit Limit</mat-label>
									<input formControlName="defcredit" matInput placeholder="Credit Limit">
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline">
                                    <mat-label>Email Invoice</mat-label>
									<mat-select formControlName="defemail_invoice">
										<mat-option value="Y">
											Yes
										</mat-option>
										<mat-option value="N">
											No
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline">
                                    <mat-label>Email Statement</mat-label>
									<mat-select formControlName="defemail_statement">
										<mat-option value="Y">
											Yes
										</mat-option>
										<mat-option value="N">
											No
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline">
                                    <mat-label>PO Required</mat-label>
									<mat-select formControlName="defrequirepo">
										<mat-option value="1">
											Yes
										</mat-option>
										<mat-option value="0">
											No
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Interest Rate</mat-label>
									<input formControlName="definterest" matInput>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline">
                                    <mat-label>Warehouse</mat-label>
									<mat-select formControlName="defwarehouse">
										<mat-option *ngFor="let l of locations" [value]="l.loccode">
											{{l.loccode}} - {{l.locationname}}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline">
                                    <mat-label>Shipping Method</mat-label>
									<mat-select formControlName="defshipvia">
										<mat-option *ngFor="let l of shipvia" [value]="l.shipper_id">
											{{l.shippername}}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline">
                                    <mat-label>Area</mat-label>
									<mat-select formControlName="defarea">
										<mat-option *ngFor="let area of areas" [value]="area.areacode">
											{{area.areacode}} - {{area.areadescription}}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									 <mat-label>Territory</mat-label>
									<mat-select formControlName="defterritory">
										<mat-option *ngFor="let area of territory" [value]="area.territory_id">
											{{area.territory_id}} - {{area.territory_name}}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline">
                                    <mat-label>Salesperson</mat-label>
									<mat-select formControlName="defsalesperson">
										<mat-option *ngFor="let sp of salespeople" [value]="sp.salesmancode">
											{{sp.salesmancode}} - {{sp.salesmanname}}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline">
                                    <mat-label>Create Customers Disabled?</mat-label>
									<mat-select formControlName="defdisabled">
										<mat-option value="1">
											Yes
										</mat-option>
										<mat-option value="0">
											No
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline">
                                    <mat-label>Tax Authority</mat-label>
									<mat-select formControlName="deftaxauth">
										<mat-option *ngFor="let tax of taxes" [value]="tax.taxgroupid">
											{{tax.taxgroupid}} - {{tax.taxgroupdescription}}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Default Branch Code</mat-label>
									<input formControlName="defbranchcode" matInput >
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline">
                                    <mat-label>Default Payment Method</mat-label>
									<mat-select formControlName="defpayment_method">
										<mat-option *ngFor="let tax of paymethod" [value]="tax.paymentid">
											{{tax.paymentname}}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</form>
</ng-container>
